// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3YvC2","row":"styles_row__Rb5dM"};